import { environment } from './../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EsnCandidatService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }
  exportCvWegestCandidatList( data:any){
    return this._http.get(this._base+`/User/download-cv/${data}`, {
      responseType: 'arraybuffer',
    });
  }
  /* get list candidat */

  getListcandidat(data: {
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/User/getCandidatesConsultants?per_page=${data?.per_page}&page=${page}`
    );
  }
 
  downloadFile(url: string) {
    return this._http.get(url, { responseType: 'blob' });
  }

  downloadPDF(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    return this._http
      .get<Blob>(url, options)
      .pipe(map((res: any) => new Blob([res], { type: 'application/pdf' })));
  }
  getPdfContent(pdfUrl: string): Observable<Blob> {
    return this._http.get(pdfUrl, { responseType: 'blob' });
  }

  // search candidat//////
  searchcandidat(data: any): Observable<ApiResponse<any>> {

    return this._http
      .post<ApiResponse<any>>(this._base + `/api/User/searchCandidate`, data)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  freeSearchcandidat(data: any): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';

    return this._http
      .post<ApiResponse<any>>(this._base + `/api/User/freeSearchCandidate`, data)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    if(str){
      for (let i = 0; i < str.length; i++) {
        if (str[i] === '"') {
          indices.push(i);
        }
      }
    }
    return indices;
  }
  /*get candidate  by id */
  getUserById(uuid: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/getConsultantDetails/${uuid}`
    );
  }
  getsuggestionById(uuid: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/getConsultantDetails/${uuid}`
    );
  }
  /* get candidate skills */
  getSkillsCandidate(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Skill/getSkillsByCandidate/${id}`
    );
  }

  // search candidat//////
  searchcandidatureext(id: number, data: any): Observable<ApiResponse<any>> {
    console.log('data', data);
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
  
    if (data?.page){ 
      data.page = data?.page +1
    }
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/CandidateJobOffer/searchInListCandidatesByESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  searchcandidatureinterne(
    id: number,
    data: any
  ): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/CandidateJobOffer/searchInListCandidatesByJobOffer/${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  // search candidat//////
  searchcandidature(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/CandidateJobOffer/searchInListCandidatesByESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  getListcandidature(data: {
    job_offer_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/CandidateJobOffer/getByJobOffer?job_offer_id=${data.job_offer_id}?
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  getListcandidatureinterne(data: {
    id: number;
    per_page?: number;
    page?: number;
  }) {
    let page = 1 
    if(data?.page) {
      page = data?.page + 1
    }
     return this._http.get<ApiResponse<any>>
     (`${this._base}/api/CandidateJobOffer/getListCandidatesforjobOfferESN/${data.id}?per_page=${data?.per_page}&page=${page}`);
  }
  //////////////////liste candidature externe /////////////////////////////////
  getListcandidatureoffre(data: {
    id: number;
    per_page?: number;
    page?: number;
  }) {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/CandidateJobOffer/getListCandidatesByESN?per_page=${data?.per_page}&page=${page}`);
  }
  /* get elment of header table list candidat */
  getHeaderElements(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`
    );
  }
  /* get elment of header table list candidat */
  changeDelectedElementHeader(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
      data
    );
  }
  listPageActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=10`
    );
  }
  /* change Sub Page State */
  changeSubPageStateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
  exportCandidat(file: any, ids: any) {
    return this._http.post(this._base + `/api/User/exportExcel`, ids, {
      responseType: 'arraybuffer',
    });
  }

  exportCandidatanonyme(file: any, data: any) {
    let ids = '';
    for (const iterator of data) {
      ids += `users_ids[]=${iterator}&`;
    }
    ids = ids.slice(0, -1);
    return this._http.get(this._base + `/api/User/exportExcelAnonyme?${ids}`, {
      responseType: 'arraybuffer',
    });
  }

  getCandidatsCompare(esn_id: any, id: number[], companyType: any) {
    let candidate_ids = '';
    for (const iterator of id) {
      candidate_ids += `candidate_ids[]=${iterator}&`;
    }
    candidate_ids = candidate_ids.slice(0, -1);
    if (companyType != 3)
      return this._http.get<ApiResponse<any>>(
        this._base + `/api/ScoreESN/compare?esn_id=${esn_id}&${candidate_ids}`
      );
    else
      return this._http.get<ApiResponse<any>>(
        this._base +
          `/api/ScoreClient/compare?client_id=${esn_id}&${candidate_ids}`
      );
  }

exportCVWegesttu(idUsers: string[], type: number) {
  let url = this._base + `/api/User/cvDownload`
  return this._http.post(url, {"type" : type, "ids" : idUsers}, {responseType: 'arraybuffer',});
}

exportCVEsn(idUser: string | undefined, type: number, idCompany? : number | null) {
  let url = this._base + `/api/User/cvDownloadForEsnSubscribed/${idUser}?type=${type}&company_id=${idCompany}`
  return this._http.get(url, {responseType: 'arraybuffer',});
}

exportCVCandidate(fileNames: string[]) {
  let url = this._base + `/api/User/downloadCvCandidate/gallery_cvs`
  return this._http.post(url, {"fileNames" : fileNames}, {responseType: 'arraybuffer',});
}

  getHeaderElementscandidatcf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeadercandidatcf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
}
